<template>
    <div class="bekijk-ook">
        <div class="video" @click="showVideo(1)">
            <div class="video__image">
                <img src="../assets/Moderniseren-thumb.jpg">
            </div>
            <div class="video__title">Het kabinet wil ons stelsel moderniseren, maar hoe?</div>
        </div>
        <div class="video" @click="showVideo(2)">
            <div class="video__image">
                <img src="../assets/Betalen-thumb.jpg">
            </div>
            <div class="video__title">Ook de manier waarop we betalen voor de eigen pensioenpot gaat veranderen. </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: "BekijkOok",
        methods: {
            showVideo(id) {
                let url;
                switch(id) {
                    case 1:
                        url = 'https://nos.nl/nieuwsuur/video/2280873-het-kabinet-wil-ons-stelsel-moderniseren-maar-hoe.html';
                        break;
                    case 2:
                        url = 'https://nos.nl/nieuwsuur/video/2280874-de-manier-waarop-we-betalen-voor-de-eigen-pensioenpot-gaat-veranderen.html';
                        break;
                }
                if (url) {
                    window.open(url);
                }
            }
        }
    }
</script>

<style lang="stylus">
    .bekijk-ook
        margin-bottom $gutter
        overflow auto

    .video
        cursor pointer
        float left
        max-width: 320px;
        width: 100%;
        margin-bottom $gutter
        &:first-child
            margin-right $gutter

    .video__image img
        width 100%

    .video__title
        margin ($gutter/2) 0 $gutter 0
        font-size .9em
        font-weight bold
        .video:hover &
            color $color-red
            text-decoration underline

</style>